var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-button",attrs:{"df":"","fdr":"","fic":"","fjc":""},on:{"click":_vm.click}},[_c('img',{attrs:{"src":"/assets/main/add.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }